import styledComponents from "styled-components";
import Fonts from "../Customs/Fonts";

export const BoldText = styledComponents.p`
    margin:0;
    font-weight:800;
    ${Fonts.poppins};
    font-size:${(props) => (props.fs != null ? props.fs : "62px")};
    word-break:break-word;
    color:${(arg) => (arg.col != null ? arg.col : "black")}
    @media (max-width:1200px){
        font-size:32px;
    }

    @media (max-width:700px){
        font-size:28px;
    }

`;

export const InnerSection = styledComponents.div`
    max-width:900px;
    padding:100px 0;
    margin:0 auto;
    color:${(props) => (props.color == null ? "white" : props.color)};

    @media (max-width:700px){
        padding:70px 0px;
    }
`;

export const Padding = styledComponents.div`
    width:inherit;
    padding:${(arg) => (arg.pad != null ? arg.pad : "0 0 100px")} ;


    // media padding
    @media (max-width:700px){
        padding:15px 0;
    }
`;
export const PaddL = styledComponents.div`
    width:inherit;
    padding-Left:100px;
`;
export const PaddR = styledComponents.div`
    width:inherit;
    padding-Right:100px;
`;
export const PaddT = styledComponents.div`
    width:inherit;
    padding-Top:100px;
`;
export const PaddB = styledComponents.div`
    width:inherit;
    padding-bottom:100px;
`;

export const FlexBox = styledComponents.div`
display:flex;
gap:20px;
color:black;
align-items:center;
margin:0 auto;

@media (max-width:800px){
    flex-direction:column;
    gap:0;
    text-align:center;
}
`;

export const HoverEffect = styledComponents.span`
opacity:0.5;

&:hover{
    opacity:1;
    transition:opacity 0.7s;
}
`;
